<template>
 <van-radio-group v-model="current" class="pay-options" @change="radioChange">
  <slot name="header"></slot>
  <div v-for="(item, index) of options" :key="index" class="option">
    <div class="option-label">
      <span>{{ item.label }}</span>
       <span v-if="item.component" class="user-inte">
        (当前积分 <component :is="item.component"></component>)
      </span>
    </div>
    <div style="display: flex;">
      <!-- <div class="payMoney" v-show="item.value === value">{{ payMoney }}</div> -->
      <van-radio :name="item.value" icon-size="15px" checked-color="#5a9dff"></van-radio>
    </div>
  </div>
</van-radio-group>
</template>
<script>

// import UserInte from '@/components/UserInte'
import UserSurplus from '@/components/UserSurplus'
import { RadioGroup, Radio } from 'vant';
// import configColor from '@/config/color.config'

const options = [
  // {
  //   label: '积分支付',
  //   value: 2,
  //   component: 'UserInte'
  // },
  // {
  //   label: '积分支付',
  //   value: 1,
  //   component: 'UserInte'
  // },
  {
    label: '微信支付',
    value: 3
  }
]

export default {
  components: {
    UserSurplus,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  model: {
    prop: 'value',
    event: 'update:value'
  },
  props: {
    value: {
      type: Number,
      default: 2
    },
    payInfo:{
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      options,
      current: this.value,
    }
  },
  computed: {
    payMoney () {
      const { payInfo, value } = this
      if (value === 3 || value === 1) {
         return `-${payInfo.payment?.money.pay_money}`
      }
      if (value === 2) {
        return `-${payInfo.payment?.jifen.pay_money}`
      }
      return ''
    }
  },
  methods: {
    radioChange (value) {
      this.$emit('update:value', value)
    }
  }
}
</script>
<style lang="scss" scoped>
  .pay-options{
   @include basic-box($padding:0.2rem, $margin:0.2rem);
  }
  .option{
    margin-bottom: 0.1rem;
    font-size: 0.27rem;
  @include flex()
  }
  .user-inte{
    color: $primary-color;
  }
  .option-label{
    display: flex;
  }
  .payMoney{
    margin: 0 0.1rem;
    color: #DE1C24;
  }
</style>